export default __webpack_public_path__ + "static/media/team45.980dc657.JPG";